// TODO: Fix cyclic dependency
// eslint-disable-next-line import/no-cycle
import logger from './logger';

export default logger;
